import '../../node_modules/leaflet/dist/leaflet.css'
import * as L from 'leaflet'
import { basemapLayer } from 'esri-leaflet'

import 'leaflet-control-geocoder/dist/Control.Geocoder.css'
import 'leaflet-control-geocoder/dist/Control.Geocoder.min.js'

import 'leaflet-mouse-position/src/L.Control.MousePosition.css'
import 'leaflet-mouse-position/src/L.Control.MousePosition'

import 'leaflet.polylinemeasure/Leaflet.PolylineMeasure.css'
import 'leaflet.polylinemeasure/Leaflet.PolylineMeasure'
/*
import '@geoman-io/leaflet-geoman-free'
import '@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css'
*/
import 'leaflet.browser.print/dist/leaflet.browser.print.min.js'

import 'leaflet-groupedlayercontrol/dist/leaflet.groupedlayercontrol.min.css'
import 'leaflet-groupedlayercontrol/dist/leaflet.groupedlayercontrol.min.js'

import 'leaflet-html-legend/dist/L.Control.HtmlLegend.css'
import 'leaflet-html-legend/dist/L.Control.HtmlLegend'

import { isArray, isEmpty } from 'lodash'

import axios from 'axios'

export function getFeatureInfoUrl (map, layers, latlng, params) {
  var point = map.latLngToContainerPoint(latlng, map.getZoom()),
    size = map.getSize(),
    bounds = map.getBounds(),
    sw = bounds.getSouthWest(),
    ne = bounds.getNorthEast()

  // sw = crs.projection._proj.forward([sw.lng, sw.lat])
  // ne = crs.projection._proj.forward([ne.lng, ne.lat])
  sw = [sw.lng, sw.lat]
  ne = [ne.lng, ne.lat]

  var defaultParams = {
    request: 'GetFeatureInfo',
    service: 'WMS',
    // srs: layer._crs.code,
    srs: 'EPSG:4674',
    styles: '',
    // version: layer._wmsVersion,
    version: '1.1.1',
    format: 'image/png',
    bbox: [sw.join(','), ne.join(',')].join(','),
    height: size.y,
    width: size.x,
    layers: layers,
    query_layers: layers,
    info_format: 'application/json',
    exceptions: 'application/json',
    feature_count: 100 // FIXME
  }

  params = L.Util.extend(defaultParams, params || {})

  params[params.version === '1.3.0' ? 'i' : 'x'] = point.x
  params[params.version === '1.3.0' ? 'j' : 'y'] = point.y

  return process.env.VUE_APP_GEOSERVER + L.Util.getParamString(params, process.env.VUE_APP_GEOSERVER, true)
}

export function getLegendGraphicUrl (name) {
  var url = new URL(process.env.VUE_APP_GEOSERVER)

  url.searchParams.append('SERVICE', 'wms')
  url.searchParams.append('REQUEST', 'GetLegendGraphic')
  url.searchParams.append('VERSION', '1.0.0')
  url.searchParams.append('FORMAT', 'image/png')
  // url.searchParams.append('WIDTH', '20')
  // url.searchParams.append('HEIGHT', '20')
  url.searchParams.append('LAYER', name)
  url.searchParams.append('TRANSPARENT', true)
//  url.searchParams.append('LEGEND_OPTIONS', 'fontName:DejaVu Sans;fontSize:12;fontAntiAliasing:true')
  url.searchParams.append('LEGEND_OPTIONS', 'fontAntiAliasing:true')

  return url.toString()
}

export function createLegend (map, group) {
  var htmlLegend = L.control.htmllegend({
    position: 'bottomleft',
    legends: [
      {
        name: 'Sistema Rodoviário Estadual',
        elements: [{
          label: ' ',
          html: '<img src="' + getLegendGraphicUrl('der:sistema_rodoviario_lin_p31982') + '">'
        }]
      }
    ],
    collapseSimple: true,
    detectStretched: true,
    collapsedOnInit: true,
    visibleIcon: 'icon icon-eye',
    hiddenIcon: 'icon icon-eye-slash'
  })

  map.addControl(htmlLegend)

  var initialLayer = true

  group.on('layeradd', (e) => {
    if(!initialLayer){
      htmlLegend.addLegend({
        name: e.layer.options.title,
        elements: [{
          label: ' ',
          html: '<img src="' + getLegendGraphicUrl(e.layer.wmsParams.layers) + '">'
        }]
      })  
    } else {
      initialLayer = false
    }
  })

  /*map.on('overlayadd', (e) => {
    let layerName  = e.name
    let layer = e.layer._name.toString()

    htmlLegend.addLegend({
      name: layerName,
      elements: [{
        label: ' ',
        html: '<img src="' + getLegendGraphicUrl(layer) + '">'
      }]
    })
  })*/

  group.on('layerremove', (e) => {
    let layerName  = e.layer.options.title

    for(var id in htmlLegend._entries) {
      if(htmlLegend._entries[id].container.innerText.indexOf(layerName) != -1) {
        htmlLegend.removeLegend(id)
      }
    }
  })

  /*map.on('overlayremove', (e) => {
    let layerName  = e.name

    for(var id in htmlLegend._entries) {
      if(htmlLegend._entries[id].container.innerText.indexOf(layerName) != -1) {
        //console.log(htmlLegend._entries[id].container)
        htmlLegend.removeLegend(id)
      }
    }
  })*/
}

export function createMeasure (map) {
  L.control.polylineMeasure({
    measureControlTitleOn: 'Medir Distância',
    measureControlTitleOff: 'Finalizar'
  }).addTo(map)
}

export function mousePosition (map) {
  L.control.mousePosition({
    position: 'bottomright'
  }).addTo(map)
}
/*
export function createEditor (map) {
  map.pm.addControls({
    position: 'topleft',
    drawCircleMarker: false
  })

  map.pm.setLang('pt-br', {
    'tooltips': {
      'placeMarker': 'Clique para posicionar o marcador',
      'firstVertex': 'Clique para posicionar o primeiro vértice',
      'continueLine': 'Clique para continuar desenhando',
      'finishLine': 'Clique em qualquer marcador existente para finalizar',
      'finishPoly': 'Clique no primeiro ponto para fechar o polígono',
      'finishRect': 'Clique para finalizar',
      'startCircle': 'Clique para posicionar o centro do círculo',
      'finishCircle': 'Clique para fechar o círculo'
    },
    'actions': {
      'finish': 'Finalizar',
      'cancel': 'Cancelar',
      'removeLastVertex': 'Remover último vértice'
    },
    'buttonTitles': {
      'drawMarkerButton': 'Desenhar um marcador',
      'drawPolyButton': 'Desenhar um polígono',
      'drawLineButton': 'Desenhar uma polilinha',
      'drawCircleButton': 'Desenhar um círculo',
      'drawRectButton': 'Desenhar um retângulo',
      'editButton': 'Editar camada(s)',
      'dragButton': 'Mover camada(s)',
      'cutButton': 'Recortar camada(s)',
      'deleteButton': 'Remover camada(s)'
    }
  }, 'en')
}
*/

export function createBaseLayers (map) {
  var baseLayers = {
    'ESRI Gray': basemapLayer('Gray'),
    'ESRI Imagery': basemapLayer('Imagery'),
    'ESRI Topographic': basemapLayer('Topographic'),
    'OpenStreetMap': L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(map),
    /*'Escritórios Regionais': L.tileLayer.wms(process.env.VUE_APP_GEOSERVER, {
      layers: ['der:escritorios_regionais_pol_p31982'],
      format: 'image/png',
      transparent: true
    })*/
  }

  return baseLayers
}

export function createGroupedOverlays () {

}

// WFS Contorno do Paraná
/*
export function getExtent () {
  axios.get(process.env.VUE_APP_GEOSERVER, {
    params: {
      service: 'wfs',
      version: '2.0.0',
      outputFormat: 'application/json',
      exceptions: 'application/json',
      request: 'GetFeature',
      typeNames: 'itcg:contorno_pr_pol_p31982_e50_a2014',
      srsName: 'EPSG:4674'
    }
  })
    .then(response => {
      console.log('getExtent')
      console.log(L.geoJson(response.data).getBounds())
    })
}
*/

export function getBounds () {
  var ne = L.latLng(-22.51664754, -48.02383566),
    sw = L.latLng(-26.71623274, -54.61930655),
    bounds = L.latLngBounds(ne, sw)

  return bounds
}

export function browserPrint () {
  return L.control.browserPrint()
}

/**
 * Converts an Object to ViewParams String.
 * @author Andre Huller <ahuller@celepar.pr.gov.br>
 * @param {Object} viewParams
 * @returns {string}
 */
export function toViewParams (viewParams) {
  //  FIXME: i --> name
  var params = []

  for (var i in viewParams) {
    var value = null

    if (isArray(viewParams[i])) {
      if (!isEmpty(viewParams[i])) {
        if (isNaN(viewParams[i][0])) {
          value = viewParams[i].map((param) => "'" + param + "'").join('\\,')
        } else {
          value = viewParams[i].join('\\,') // FIXME ??
        }
      }
    } else if (viewParams[i]) {
      value = viewParams[i]
    }

    if (value) {
      params.push([i, value].join(':'))
    }
  }

  return params.join(';')
}

/* Custom Controls */
/**
 * Creates the GetFeatureInfo Control
 * @author Andre Huller <ahuller@celepar.pr.gov.br>
 */
/*
export function getFeatureInfo (map, layer) {
  L.Control.GetFeatureInfo = L.Control.extend({
    options: {
      position: 'topleft',
      text: 'Informações',
      title: 'Informações',
      className: 'leaflet-control-getfeatureinfo',
      enabled: false
    },
    onAdd: function (map) {
      this._map = map
      var container = L.DomUtil.create('div', 'leaflet-bar '
        + this.options.className)

      var link = L.DomUtil.create('a', this.options.className + '-toggle', container)
      link.href = "#"
      link.title = this.options.title

      L.DomEvent
        .on(link, 'mousedown dblclick', L.DomEvent.stopPropagation)
        .on(link, 'click', L.DomEvent.stop)
        .on(link, 'click', this._toggleGetFeatureInfo, this)

      this._anchor = link
      return container
    },
    onRemove: function () {
      // ..
    },
    _toggleGetFeatureInfo: function () {
      this.options.enabled = !this.options.enabled
      if (this.options.enabled) {
        this._map.on('click', this._getFeatureInfo, this)
        this._anchor.classList.add('leaflet-control-active')
      } else {
        this._map.off('click', this._getFeatureInfo, this)
        this._anchor.classList.remove('leaflet-control-active')
      }
    },
    _getFeatureInfo: function (e) {
      var url = getFeatureInfoUrl(this._map, layer, e.latlng)

      var template = `
        <h2>{nome}</h2>
        <p><strong>Código IBGE</strong>: {codibge}</p>
        <p><strong>Dirigente Municipal</strong>: {dirigentemunicipal}</p>
        <p><strong>E-mail Dirigente Municipal</strong>: {email}</p>
        <p><strong>População</strong>: {pop2010}</p>
        <p><strong>IDHM (2000)</strong>: {idhm_2000}</p>
      `

      axios.get(url)
        .then(response => {
          console.log(response.data)
          var feature = response.data.features[0]

          if (feature) {
            L.popup()
              .setLatLng(e.latlng)
              .setContent(L.Util.template(template, feature.properties))
              .openOn(this._map)
          }
        })
        .catch(error => {
          console.log(error)
        })
    }
  })

  return new L.Control.GetFeatureInfo(map)
}
*/

export function homeExtent (map) {
  L.Control.HomeExtent = L.Control.extend({
    options: {
      position: 'topleft',
      text: 'Visão Inicial',
      title: 'Visão Inicial',
      className: 'leaflet-control-homeextent'
    },
    onAdd: function (map) {
      this._map = map
      var container = L.DomUtil.create('div', 'leaflet-bar '
        + this.options.className)

      // this._container = container

      var link = L.DomUtil.create('a', this.options.className + '-toggle', container)
      link.href = "#"
      // link.innerHTML = this.options.text
      link.title = this.options.title

      L.DomEvent
        .on(link, 'mousedown dblclick', L.DomEvent.stopPropagation)
        .on(link, 'click', L.DomEvent.stop)
        .on(link, 'click', this._fitBounds, this)

      return container
    },
    onRemove: function () {
      // ..
    },
    _fitBounds: function () {
      this._map.fitBounds(getBounds())
    }
  })

  return new L.Control.HomeExtent(map)
}

export function clearMap (map) {
  L.Control.ClearMap = L.Control.extend({
    options: {
      position: 'topleft',
      text: 'Limpar mapa',
      title: 'Limpar mapa',
      className: 'leaflet-control-clearmap'
    },
    onAdd: function (map) {
      this._map = map
      var container = L.DomUtil.create('div', 'leaflet-bar '
        + this.options.className)

      // this._container = container

      var link = L.DomUtil.create('a', this.options.className + '-toggle', container)
      link.href = "#"
      // link.innerHTML = this.options.text
      link.title = this.options.title

      L.DomEvent
        .on(link, 'mousedown dblclick', L.DomEvent.stopPropagation)
        .on(link, 'click', L.DomEvent.stop)
        .on(link, 'click', this._clearMap, this)

      return container
    },
    onRemove: function () {
      // ..
    },
    _clearMap: function () {
      map.eachLayer((layer) => {
        console.log(layer)
        //this._map.remove(layer)
      })
    }
  })

  return new L.Control.ClearMap(map)
}

export function watermark () {
  L.Control.Watermark = L.Control.extend({
    onAdd: function () { /* map */
      var img = L.DomUtil.create('img')
      img.src = require('@/assets/logo.png')
      img.style.width = '200px'

      return img
    },
    onRemove: function () { /* map */
      // Nothing to do here
    }
  })

  L.control.watermark = function (opts) {
    return new L.Control.Watermark(opts)
  }

  return L.control.watermark({
    position: 'bottomleft'
  })
}

export function createWmsLayer(name, title) {
  return L.tileLayer.wms(process.env.VUE_APP_GEOSERVER, {
    layers: name,
    format: 'image/png',
    transparent: true,
    pane: 'overlayPane',
    title: title
  })
}

export function createGeoJson(name, template, callback) {
  var params = {
    service: 'wfs',
    version: '2.0.0',
    outputFormat: 'application/json',
    exceptions: 'application/json',
    request: 'GetFeature',
    typeNames: name,
    srsName: 'EPSG:4674'
  }

  axios.get(process.env.VUE_APP_GEOSERVER, {
    params: params
  })
    .then(response => {
      var geojson = L.geoJson(response.data, {
        onEachFeature: (feature, layer) => {
          var popupContent = "<table>"
          for(var header of template) {
            popupContent += "<tr><th>" + header.text + ":</th>" +
              "<td>" + feature.properties[header.value] + "</td></tr>"
          }
          popupContent += "</table>"
          layer.bindPopup(popupContent)
        },
        opacity: 0,
        style: {
          opacity: 0,
          fillOpacity: 0
        },
        pointToLayer: function (feature, latlng) {
          return L.circleMarker(latlng, {
            opacity: 0,
            fillOpacity: 0
          })
        }
      })

      callback(geojson)
    })
    .catch(error => {
      console.log(error)
    })
}

export function toUrlParams(obj) {
  var pairs = []

  for (var prop in obj) {
    var k = prop,
        v = obj[prop]
    pairs.push( k + "=" + v)
  }

  return "?" + pairs.join("&")
}

export function getTextColor (camada, codigo) {
  const color = {
    'cop' : {
      1 :   '#48dc2d',
      2 :   '#8ef09d',
      3 :   '#ed4a89',
      4 :   '#0e49ea',
      5 :   '#7947cf',
      6 :   '#e5da71',
      7 :   '#86d343',
      8 :   '#8ac0e7',
      9 :   '#abc840',
      10 :  '#b244e5',
      11 :  '#71c99a',
      12 :  '#e91dec',
      13 :  '#5b54bd',
      14 :  '#50d0de',
      15 :  '#65e0c6',
      16 :  '#eb754a',
      17 :  '#eab871',
      18 :  '#e974c6',
      'default' : '#000000'
    },
    'cremep' : {
      1 :   '#5d95e9',
      2 :   '#5617cc',
      3 :   '#d383f0',
      4 :   '#e067a6',
      5 :   '#d2b180',
      6 :   '#141be5',
      7 :   '#5fd0bf',
      8 :   '#79d382',
      9 :   '#97de7d',
      10 :  '#800000',
      11 :  '#2cb9df',
      12 :  '#a4cb5a',
      13 :  '#efec21',
      14 :  '#7cd7a8',
      15 :  '#cf18ba',
      'default' : '#000000'
    },
    'novoPrograma' : {
      'CO124/2021 DOP' :   '#A020F0',
      'CO123/2021 DOP' :   '#FA8072',
      'default'        :   '#000000'
    },
    'anelAntigo' : {
      'Noroeste'      :   '#A020F0',
      'Norte'         :   '#FA8072',
      'Oeste'         :   '#FFA500',
      'Leste'         :   '#D8BFD8',
      'Campos Gerais' :   '#7F7F7F',
      'default'       :   '#000000'
    } 
  };
return (color[camada][codigo] || color[camada]['default']);
}